<div id="c-catalog-player">
  <iframe #player id="catalog-module-container" *ngIf="this.iframeSrc && isPrerender === false" [src]="this.iframeSrc" frameborder="0"></iframe>
  <div class="catalog-preview" *ngIf="isPrerender">
    <div class="catalog-details" *ngIf="this.catalogName && this.catalogImage">
      <img class="catalog-image" src="{{this.catalogImage}}" alt="Catalog cover" (click)="showCatalog()">
      <div class="catalog-name__wrapper">
        <h1 class="catalog-name">
          {{this.catalogName}}
        </h1>
        <button class="btn btn--blue" (click)="showCatalog()">Esplora</button>
      </div>
    </div>
  </div>
</div>

<div class="share-catalog" *ngIf="!isPrerender">
  <h3>Condividi</h3>
  <div class="share-catalog__icons">
    <a target="_blank" class="facebook" href="https://www.facebook.com/sharer/sharer.php?u={{this.location}};src=sdkpreparse">
      <img class="icon" src="./assets/images/icons/facebook.svg" alt="facebook icon">
      <img class="icon-hover" src="./assets/images/icons/facebook_hover.svg" alt="facebook icon">
    </a>
    <a target="_blank" class="email" (click)="toggleAccordion()">
        <img class="icon" src="./assets/images/icons/mail.svg" alt="mail icon">
        <img class="icon-hover" src="./assets/images/icons/mail_hover.svg" alt="mail icon">
    </a>
    <a target="_blank" class="whastapp" href="https://wa.me/?text={{this.location}}">
        <img class="icon" src="./assets/images/icons/whatsapp.svg" alt="whatsapp icon">
        <img class="icon-hover" src="./assets/images/icons/whatsapp_hover.svg" alt="whatsapp icon">
    </a>
    <a target="_blank" class="linkedin" href="https://www.linkedin.com/shareArticle?mini=true&url={{this.location}}&title={{ this.catalogName }}">
        <img class="icon" src="./assets/images/icons/LinkedIn.svg" alt="LinkedIn icon">
        <img class="icon-hover" src="./assets/images/icons/LinkedIn_hover.svg" alt="LinkedIn icon">
    </a>
  </div>
</div>
<div class="form-container" #formEmail [class.accordion-open]="isAccordionOpen">
  <form class="form-container__form" [formGroup]="shareEmail" (ngSubmit)="senderMail()" >
    <div class="form-container__form-content">
      <h4>Inserisci l'indirizzo email</h4>
      <p>Condividi il catalogo con chi vuoi.</p>
      <input type="email" formControlName="email" placeholder="Indirizzo email">
      <div class="errors"  *ngIf="shareEmail.get('email').invalid && shareEmail.get('email').touched">
        <p *ngIf="shareEmail.get('email').hasError('required')">L'email è obbligatoria.</p>
        <p *ngIf="shareEmail.get('email').hasError('email')">Inserisci un'email valida.</p>
      </div>
      <button [disabled]="shareEmail.invalid" type="submit" class="btn btn--brand-color-03">Condividi</button>
    </div>
  </form>
</div>


<div class="debug">
  {{uaDebug}} ---- {{this.isPrerender}}
</div>
